import React from 'react';

const FlecheCercleSvg = ({width = 20, height = 20, couleur = "red"}) => (
    <svg width={width} height={height} viewBox="0 0 42 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M7.7156 15.956C8.56929 12.9787 10.3436 10.3481 12.7842 8.44118C15.2247 6.5343 18.2063 5.44906 21.3015 5.34097C24.3967 5.23287 27.4467 6.10748 30.0143 7.83946C32.5819 9.57143 34.5354 12.0719 35.5947 14.9824"
            stroke={couleur} strokeWidth="4" strokeLinejoin="round"/>
        <path
            d="M35.3259 25.703C34.2226 28.3179 32.3845 30.5565 30.0343 32.1473C27.6841 33.7381 24.9228 34.6129 22.0854 34.6655C19.2479 34.718 16.4562 33.9462 14.0486 32.4435C11.6411 30.9409 9.72126 28.7719 8.52188 26.1997"
            stroke={couleur} strokeWidth="4" strokeLinejoin="round"/>
        <path d="M14.6694 25.0392L7.24617 25.5251L4.48953 32.5867" stroke={couleur} strokeWidth="4"/>
        <path d="M28.791 15.6016L36.5001 15.5826L39.1322 8.56371" stroke={couleur} strokeWidth="4"/>
    </svg>
);

export default FlecheCercleSvg;
